export const Role = {
  Admin: 'admin',
  Editor: 'editor',
  Viewer: 'viewer',
  Accountant: 'accountant'
}
